import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";

import "react-data-table-component-extensions/dist/index.css";
import Header from "../layouts/CustomerHeader";
import Sidebar from "../layouts/CustomerSidebar";
import axios from "../api/axios";
import {  Apitoken, Authtoken } from "../Global";

const CustomerContacts = () => {
  const [menu, setMenu] = useState(false);
  const [businesses, setBusinesses] = useState([]);
  const [logistics, setLogistics] = useState([]);
  const [qualities, setQualities] = useState([]);

  useEffect(() => {
    axios
      .post(
        "/customerportal/called-contacts/listing",
        {},
        {
          headers: { Authorization: `${Authtoken}`, Apitoken: Apitoken },
        }
      )
      .then((response) => {
        if (response.data.code === 200) {
          setBusinesses(response.data.data.business);
          setLogistics(response.data.data.logistics);
          setQualities(response.data.data.qualities);
        }else{
        //  window.location.href = "/login";
        }
       
      })
      .catch((error) => {
        console.log(error);
      });
  }, []);


  const toggleMobileMenu = () => {
    setMenu(!menu);
  };


  return (
    <>
      <div className={`main-wrapper customer-portal-main  ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={() => toggleMobileMenu()} />
        <Sidebar />

        <div className="page-wrapper">
          <div className="content container-fluid">
            <div className="page-header">
              <div className="row align-items-center">
                <div className="col">
                  <h3 className="page-title">Loadings</h3>
                  <ul className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/customerportal/profile">Dashboard</Link>
                    </li>
                    <li className="breadcrumb-item active">                                       Loadings
                    </li>
                  </ul>
                </div>
              
              </div>
            </div>

            <div className="row">
              <div className="col-sm-12">
                <div className="card card-table">
                <div className="card card-table">
                  <div className="card-body" style={{padding:'20px'}}>
                  <div className="table-responsive">
                  <h5 className="card-title">Business</h5>

                    <table className="table table-bordered">
                        <thead>
                          <tr>
                              <th className="p-3">Name</th>
                              <th className="p-3">Email</th>
                              <th className="p-3">Phone Number</th>
                              <th className="p-3">Position</th>
                        </tr>
                        </thead>
                      <tbody>
                        {businesses &&
                          businesses.map((item, indx) => (
                            <tr key={item.name || indx}>
                              <td className="p-3">{item.name}</td>
                              <td className="p-3">{item.email}</td>
                              <td className="p-3">{item.phone_number}</td>
                              <td className="p-3">{item.position}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>                    

                  </div>
                  <div className="table-responsive">
                    <br/>
                  <h5 className="card-title">Logistics</h5>

                    <table className="table table-bordered">
                        <thead>
                          <tr>
                              <th className="p-3">Name</th>
                              <th className="p-3">Email</th>
                              <th className="p-3">Phone Number</th>
                              <th className="p-3">Position</th>
                        </tr>
                        </thead>
                      <tbody>
                        {logistics &&
                          logistics.map((item, indx) => (
                            <tr key={item.name || indx}>
                              <td className="p-3">{item.name}</td>
                              <td className="p-3">{item.email}</td>
                              <td className="p-3">{item.phone_number}</td>
                              <td className="p-3">{item.position}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>                    

                  </div>
                  <div className="table-responsive">
                  <br/>

                  <h5 className="card-title">Quality</h5>

                    <table className="table table-bordered">
                        <thead>
                          <tr>
                              <th className="p-3">Name</th>
                              <th className="p-3">Email</th>
                              <th className="p-3">Phone Number</th>
                              <th className="p-3">Position</th>
                        </tr>
                        </thead>
                      <tbody>
                        {qualities &&
                          qualities.map((item, indx) => (
                            <tr key={item.name || indx}>
                              <td className="p-3">{item.name}</td>
                              <td className="p-3">{item.email}</td>
                              <td className="p-3">{item.phone_number}</td>
                              <td className="p-3">{item.position}</td>
                            </tr>
                          ))}
                      </tbody>
                    </table>                    

                  </div>
                
                  </div>
                </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default CustomerContacts;
